export default __webpack_public_path__ + "b50b6356ef012bfc75d5473508d47300.png";